import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchDeprtmentData = createAsyncThunk(
  "api/department",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-department/`);
    const data = await response.json();
    return data;
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    departmentdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeprtmentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeprtmentData.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentdata = action.payload;
      })
      .addCase(fetchDeprtmentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;
